import { withStyles } from '@material-ui/core';
import InputBase from './InputBase';
import styles from './InputBase.styles';

export default withStyles(styles)(InputBase);
